import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgOtpInputModule } from  'ng-otp-input';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PortalInterceptor } from './shared/interceptors/portal.interceptor';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HttpClientModule } from '@angular/common/http';
import { JwtHelperService, JWT_OPTIONS  } from '@auth0/angular-jwt';

import {
  AvatarModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonGroupModule,
  ButtonModule,
  CardModule,
  DropdownModule,
  MultiSelectModule,
  FooterModule,
  FormModule,
  GridModule,
  HeaderModule,
  ListGroupModule,
  NavModule,
  ProgressModule,
  SharedModule,
  SidebarModule,
  TabsModule,
  UtilitiesModule,
  SpinnerModule,
  ModalModule,
  SmartTableModule,
  TableModule,
  AlertModule,
  CollapseModule,
  DatePickerModule,
  NavbarModule,
  TooltipModule,
  DateRangePickerComponent
} from '@coreui/angular-pro';

import { IconModule, IconSetService } from '@coreui/icons-angular';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LogoutComponent } from './logout/logout/logout.component';
import { DefaultLayoutComponent } from './containers';
import { DefaultAsideComponent } from './containers';
import { DefaultHeaderComponent } from './containers';
import { DefaultFooterComponent } from './containers';
import { EmailLayoutComponent } from './containers';
import { ChangepasswordComponent } from './login/changepassword/changepassword.component';
import { CorporateMakerComponent } from './pages/makers/corporate-maker/corporate-maker.component';
import { AdminMakerComponent } from './pages/makers/admin-maker/admin-maker.component';
import { CorporateCheckerComponent } from './pages/checkers/corporate-checker/corporate-checker.component';
import { AdminCheckerComponent } from './pages/checkers/admin-checker/admin-checker.component';
import { ManageCustomerComponent } from './pages/checkers/manage-customer/manage-customer.component';
import { AlertBoxComponentComponent } from './shared/alertbox/alert-box-component/alert-box-component.component';
import { DhabiLoaderComponent } from './shared/loader/dhabi-loader/dhabi-loader.component';
import { GlobalDataComponent } from './shared/global/global-data/global-data.component';
import { CorporateLeadsComponent } from './pages/makers/corporate-leads/corporate-leads.component';
import { RetailAdminComponent } from './pages/makers/retail-admin/retail-admin.component';
import { RetailCustomerListComponent } from './pages/makers/retail-admin/retail-customers/retail-customerList.component';
import { RetailClientClassificationComponent } from './pages/makers/retail-admin/retail-clientClassification/retail-clientClassification.component';
import { SupportAdminComponent } from './pages/makers/support-admin/support-admin.component';
import { SupportComplaintsComponent } from './pages/makers/support-complaints/support-complaints.component';
import { SupportComplaintsUpdateStatusComponent } from './pages/makers/support-complaints/support-complaintsUpdateStatus/support-complaintsUpdateStatus.component';
import { SupportProspectiveCustomersComponent } from './pages/makers/support-prospective-customers/support-prospective-customers.component';
import { SupportHoldQueAuditLogComponent } from './pages/makers/support-hold-que-audit-log/support-hold-que-audit-log.component';
import { SupportUserProfileAuditReportComponent } from './pages/makers/support-user-profile-audit-report/support-user-profile-audit-report.component';
import { SupportUserPermissionAuditReportComponent } from './pages/makers/support-user-permission-audit-report/support-user-permission-audit-report.component';
import { PageNotFoundComponent } from './pages/general/page-not-found/page-not-found.component';
import { OnboardingComponent } from './pages/makers/retail-admin/onboarding/onboarding.component';
import { InvitationsComponent } from './pages/makers/retail-admin/invitations/invitations.component';
import { DecisionTableComponent } from './pages/makers/retail-admin/onboarding/decision-table/decision-table.component';
import { SwiftTransferComponent } from './pages/makers/swift-transfer/swift-transfer.component';
import { NumberOnlyDirective } from './shared/number-only.directive';
import { InvitationListComponent } from './pages/makers/retail-admin/invitations/invitation-list/invitation-list.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

const APP_CONTAINERS = [
  DefaultAsideComponent,
  DefaultFooterComponent,
  DefaultHeaderComponent,
  DefaultLayoutComponent,
  EmailLayoutComponent
];

@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    DashboardComponent,
    LogoutComponent,
    DefaultAsideComponent,
    DefaultHeaderComponent,
    DefaultFooterComponent,
    EmailLayoutComponent,
    DefaultLayoutComponent,
    ChangepasswordComponent,
    CorporateMakerComponent,
    AdminMakerComponent,
    CorporateCheckerComponent,
    AdminCheckerComponent,
    ManageCustomerComponent,
    AlertBoxComponentComponent,
    DhabiLoaderComponent,
    GlobalDataComponent,
    CorporateLeadsComponent,
    RetailAdminComponent,
    RetailCustomerListComponent,
    RetailClientClassificationComponent,
    SupportAdminComponent,
    SupportComplaintsComponent,
    SupportComplaintsUpdateStatusComponent,
    SupportProspectiveCustomersComponent,
    SupportHoldQueAuditLogComponent,
    SupportUserProfileAuditReportComponent,
    SupportUserPermissionAuditReportComponent,
    PageNotFoundComponent,
    OnboardingComponent,
    InvitationsComponent,
    DecisionTableComponent,
    SwiftTransferComponent,
    NumberOnlyDirective,
    InvitationListComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BrowserModule,
    AppRoutingModule,
    AvatarModule,
    BreadcrumbModule,
    FooterModule,
    DropdownModule,
    MultiSelectModule,
    GridModule,
    HeaderModule,
    SidebarModule,
    IconModule,
    NavModule,
    ButtonModule,
    FormModule,
    UtilitiesModule,
    ButtonGroupModule,
    SidebarModule,
    SharedModule,
    TabsModule,
    ListGroupModule,
    ProgressModule,
    BadgeModule,
    ListGroupModule,
    CardModule,
    FormsModule,
    HttpClientModule,
    NgScrollbarModule,
    ReactiveFormsModule,
    SpinnerModule,
    ModalModule,
    NgOtpInputModule,
    SmartTableModule,
    TableModule,
    AlertModule,
    CollapseModule,
    DatePickerModule,
    CommonModule,
    NavbarModule,
    TooltipModule,
    DateRangePickerComponent,
    TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
  ],
  providers: [
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: PortalInterceptor, multi: true},
    JwtHelperService,
    IconSetService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
